import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { TypeService } from '../../service/lcontype/type.service';
import zh from '@angular/common/locales/zh'
import { registerLocaleData } from '@angular/common';
// import { TestQueryService } from "../../test-query.service";
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzMessageService } from 'ng-zorro-antd/message';

import { TestWeiyunService } from '../../test.weiyun.service'

registerLocaleData(zh)

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.less']
})
export class SidebarComponent implements OnInit {
  // 发布订阅

  // 基础图形显示隐藏
  public falg = false;
  // Visible=false;
  // 数据源显示隐藏
  public hidde = false;
  // 添加数据源
  isVisible = false;
  // 图层列表
  public arr = [];
  // // 排列几行几列
  public line: any;
  public column: any;
  // 所需图形
  public shape: any;
  // 数据表单
  public poolName: any;
  public driverClassName: any;
  public url: any; //连接地址
  public username: any; //用户名
  public password: any; //密码

  // 原本数据源
  public arrdata = [];
  // 添加的数据源
  public addname: any;
  // 新建指标
  Visible = false;
  // 新建指标数据
  public field: any;
  // 数据源选择器
  public selectedValue: any;
  // 对应表名
  public tablearr = [];
  public table: any;
  // 对应列名
  public columnarr = [];
  public columndata: any;
  dateRange: any;
  radioValue = '数值类型';
  public unit: any;
  public currency: any;
  public summaryFunction: any;
  public isNum: any;
  public isDate: any;
  // 表名
  public dbName: any;
  // 列名
  public columnename: any;
  // 全局参数
  public allData: any = [{ x: 0, y: 0, refresh: "-1" }]
  // 新建模板
  modelvisible = false;
  // 新建模型数据
  public modelname: any;
  checked = false;
  // 选中指标的模型数据
  public modelarr = [];
  public indexarr = [];
  t1: any;
  c1: any;
  c2: any;
  test: any;
  test1: any
  assionarr: any;
  relation: any = "";
  operation: any = "";
  countname: any = "";
  tableAllName: any;
  isDatecolum: any;
  // 储存的所有指标
  pointData: any = [];
  // 左边指标
  leftPoint: any;
  // 右边指标
  rightPoint: any;
  // 操作值
  pointTip: any;
  // 选择的模块值
  moduleSelect: any;
  // 所有存储的指标
  listOfOption: any = [];
  listOfSelectedValue = [];
  defaultOption = [...this.listOfSelectedValue];
  // 模块的总集合
  moduleData: any = [];
  demoValue: any = 0;
  // 模块详情
  modulesFlag: Boolean = false;
  // 指标详情
  builtFlag: Boolean = false;
  // 展示指标内容
  builtContents: any = [];
  // 展示模块内容
  modelContent: any = [];
  // 数据源
  graDatasoure: any;
  // 加载中
  isSpinning:any = false;

  // 组件列表
  public menulist: any = [
    {
      picUrl: 'assets/基础.svg',
      title: '基础'
    },
    {
      picUrl: 'assets/高级版.svg',
      title: '高级'
    },
    {
      picUrl: 'assets/地图.svg',
      title: '地图'
    },
    {
      picUrl: 'assets/多媒体.svg',
      title: '媒体'
    },
    {
      picUrl: 'assets/3d.svg',
      title: '3D'
    },
  ]
  // 图层列表
  // 暂时注释掉打包看看 2023-10-31
  public chartlist = [
    // {
    //   picUrl: 'assets/堆叠条形图.svg',
    //   content: '堆叠条形图',
    //   title: { type: "barchart", orientation: "horizontal", stacking: "normal" }
    // },
    // {
    //   picUrl: 'assets/堆叠柱状图.svg',
    //   content: '层叠柱状图',
    //   title: { type: "barchart", orientation: "vertical", stacking: "normal" }
    // },
    // {
    //   picUrl: 'assets/条形图.svg',
    //   content: '分组条形图',
    //   title: { type: "barchart", orientation: "horizontal" }
    // },
    // {
    //   picUrl: 'assets/柱状图.svg',
    //   content: '分组柱状图',
    //   title: { type: "barchart", orientation: "vertical" }
    // },
    // {
    //   picUrl: 'assets/百分比条形堆叠图.svg',
    //   content: '百分比图',
    //   title: { type: "p-percentage" }
    // },
    // {
    //   picUrl: 'assets/堆叠柱状图.svg',
    //   content: '百分比堆叠柱',
    //   title: { type: "barchart", orientation: "vertical", stacking: "percent" }
    // },
    // {
    //   picUrl: 'assets/折线图.svg',
    //   content: '时间折线图',
    //   title: { type: "timeseries" }
    // },
    // {
    //   picUrl: 'assets/面积图.svg',
    //   content: '面积图',
    //   title: { type: "p-onlylmpoly" }
    // },
    // {
    //   picUrl: 'assets/堆叠面积图.svg',
    //   content: '堆叠面积图',
    //   title: { type: "polyline-p-lmpolyline" }
    // },
    // {
    //   picUrl: 'assets/饼状图.svg',
    //   content: '饼状图',
    //   title: { type: "piechart" }
    // },
    // {
    //   picUrl: 'assets/散点图.svg',
    //   content: '散点图',
    //   title: { type: "michaeldmoore-scatter-panel" }
    // },
    // {
    //   picUrl: 'assets/气泡图.svg',
    //   content: '气泡图',
    //   title: { type: "p-bubble" }
    // },
    // {
    //   picUrl: 'assets/矩形树状图.svg',
    //   content: '矩形树状图',
    //   title: { type: "marcusolsson-treemap-panel" }
    // },
    // {
    //   picUrl: 'assets/表格图.svg',
    //   content: '表格图',
    //   title: { type: "table" }
    // },
    // {
    //   picUrl: 'assets/table.svg',
    //   content: '销量图',
    //   title: { type: "my-broken" }
    // },
    // {
    //   picUrl: 'assets/柱状图.svg',
    //   content: '分类柱状图',
    //   title: { type: "bilibala-echarts-panel",typeName:"分组柱状图" }
    // },

    // 以区分Echarts图表以及上边部分是前作者完成   Wu  由于里边还有一些属性需要修改所以暂时先不注释掉这些 先做大方面的类型定位
  ]
  public barList = [
    {
      picUrl: 'assets/柱状图.svg',
      content: '常规柱状图',
      title: { type: "echarts-new-pic",typeName:"常规柱状图" }
    },
    {
      picUrl: 'assets/柱状图.svg',
      content: '可缩放柱状图',
      title: { type: "echarts-new-pic",typeName:"缩放柱状图" }
    },
    {
      picUrl: 'assets/柱状图.svg',
      content: '带缩放按钮柱状图',
      title: { type: "echarts-new-pic",typeName:"按钮柱状图" }
    },
    {
      picUrl: 'assets/多数柱状图.svg',
      content: '多数柱状图',
      title: { type: "echarts-new-pic",typeName:"多数柱状图" }
    },
    {
      picUrl: 'assets/多变柱状图.svg',
      content: '多变柱状图',
      title: { type: "echarts-new-pic",typeName:"多变柱状图" }
    },
    {
      picUrl: 'assets/堆叠柱状图.svg',
      content: '堆叠柱状图',
      title: { type: "echarts-new-pic",typeName:"堆叠柱状图" }
    },
    {
      picUrl: 'assets/瀑布图.svg',
      content: '瀑布图',
      title: { type: "echarts-new-pic",typeName:"瀑布图" }
    }
  ]
  public yBarList = [
    {
      picUrl: 'assets/条形图.svg',
      content: '常规条形图',
      title: { type: "echarts-new-pic",typeName:"常规条形图" }
    },
    {
      picUrl: 'assets/条形图.svg',
      content: '可切换数据条形图',
      title: { type: "echarts-new-pic",typeName:"条形切换图" }
    },
    {
      picUrl: 'assets/多数条形图.svg',
      content: '多数条形图',
      title: { type: "echarts-new-pic",typeName:"多数条形图" }
    },
    {
      picUrl: 'assets/堆叠条形图.svg',
      content: '堆叠条形图',
      title: { type: "echarts-new-pic",typeName:"堆叠横条图" }
    },
  ]
  public pieList = [
    {
      picUrl: 'assets/饼状图.svg',
      content: '常规饼图',
      title: { type: "echarts-new-pic",typeName:"常规饼图" }
    },
    {
      picUrl: 'assets/环形饼图.svg',
      content: '环形饼图',
      title: { type: "echarts-new-pic",typeName:"环形饼图" }
    },
    {
      picUrl: 'assets/南丁格尔玫瑰图.svg',
      content: '玫瑰图',
      title: { type: "echarts-new-pic",typeName:"玫瑰图" }
    },
    {
      picUrl: 'assets/饼状图.svg',
      content: '分割饼图',
      title: { type: "echarts-new-pic",typeName:"分割饼图" }
    },
    {
      picUrl: 'assets/饼状图.svg',
      content: '可切换数据饼图',
      title: { type: "echarts-new-pic",typeName:"切换饼图" }
    },
  ]
  public lineList = [
    {
      picUrl: 'assets/折线图.svg',
      content: '常规折线图',
      title: { type: "echarts-new-pic",typeName:"常规折线图" }
    },
    {
      picUrl: 'assets/折线图.svg',
      content: '可切换数据折线图',
      title: { type: "echarts-new-pic",typeName:"折线切换图" }
    },
    {
      picUrl: 'assets/折线图.svg',
      content: '带缩放按钮折线图',
      title: { type: "echarts-new-pic",typeName:"按钮折线图" }
    },
    {
      picUrl: 'assets/折线面积图.svg',
      content: '折线面积图',
      title: { type: "echarts-new-pic",typeName:"折线面积图" }
    },
    {
      picUrl: 'assets/面性图表折线柱状图.svg',
      content: '折线柱状图',
      title: { type: "echarts-new-pic",typeName:"折线柱状图" }
    },
    {
      picUrl: 'assets/折线对比图.svg',
      content: '折线对比图',
      title: { type: "echarts-new-pic",typeName:"折线对比图" }
    },
    {
      picUrl: 'assets/折线图.svg',
      content: '浅色堆叠面积图',
      title: { type: "echarts-new-pic",typeName:"浅色面积图" }
    },
    {
      picUrl: 'assets/梯度堆叠面积图.svg',
      content: '梯度堆叠面积图',
      title: { type: "echarts-new-pic",typeName:"梯度堆叠面积图" }
    }
  ]
  public liquidList = [
    {
      picUrl: 'assets/百分比条形堆叠图.svg',
      content: '单数据进度图',
      title: { type: "echarts-new-pic",typeName:"进度图" }
    },
    {
      picUrl: 'assets/雷达图.svg',
      content: '极坐标图',
      title: { type: "echarts-new-pic",typeName:"极坐标" }
    },
  ]
  public radarLsit = [
    {
      picUrl: 'assets/雷达图.svg',
      content: '基本雷达图',
      title: { type: "echarts-new-pic",typeName:"基本雷达图" }
    },
    {
      picUrl: 'assets/雷达面积图.svg',
      content: '雷达面积图',
      title: { type: "echarts-new-pic",typeName:"面积雷达图" }
    },
    {
      picUrl: 'assets/雷达图.svg',
      content: '可切换数据雷达图',
      title: { type: "echarts-new-pic",typeName:"变化雷达图" }
    }
  ]
  public scatterList = [
    {
      picUrl: 'assets/散点图.svg',
      content: '常规散点图',
      title: { type: "echarts-new-pic",typeName:"常规散点图" }
    },
    {
      picUrl: 'assets/散点图.svg',
      content: '波动图',
      title: { type: "echarts-new-pic",typeName:"波动图" }
    },
    {
      picUrl: 'assets/折线散点图.svg',
      content: '折线散点图',
      title: { type: "echarts-new-pic",typeName:"折线散点图" }
    },
  ]
  fieldIndex: any = 0;
  isCollapsed: boolean;
  saveData: any;
  fbFalg: boolean;

  timeData: any;
  detailId: string;
  newTitle: any = "新建指标";
  editFlag: boolean = false;
  editFlagModel: boolean = false;
  showBuilt: any = [];
  showModel: any = [];
  // 修改的id
  editId: any;
  // 是否分组
  isGroup:any
  // 模板计算
  numTest:any = [{leftPoint:"",pointTip:"",rightPoint:""},{leftPoint:"",pointTip:"",rightPoint:""}];
  // 模板说明
  modelDetail:any;
  // 数据库提示
  sqlTip:any;
  // 获取数据id
  sourDataId:any;
  // 获取选择的指标名称
  selectedName:any = [{name:null,value:null}];
  // 选择的指标名称
  indexName:any = [];
  // 排序类型
  sortType:any = "降序";
  // 排序数量
  sortNum:any = null;

  constructor(
    public http: HttpClient,
    public srv: TypeService,
    private modalService: NzModalService,
    public ml: TestWeiyunService,
    private message: NzMessageService,
    private nzMessageService: NzMessageService,
  ) { }

  showModal(): void {
    this.isVisible = true;
    this.driverClassName = "com.mysql.cj.jdbc.Driver";
    this.sqlTip = "jdbc:mysql://主机名:端口名/数据库名";
  }
  oracleModel(): void {
    this.isVisible = true;
    this.driverClassName = "oracle.jdbc.driver.OracleDriver";
    this.sqlTip = "jdbc:oracle:thin:@主机名:端口名:数据库名";
  }
  // 新建指标
  news(): void {
    this.Visible = true;

    this.countname = null;
    this.relation = null;
    this.operation = null;
    this.field = null;
    this.selectedValue = null;
    this.table = null;
    this.columndata = null;
    this.t1 = null;
    this.c1 = null;
    this.c2 = null;
    this.isDatecolum = null;
    this.summaryFunction = null;
    this.editFlag = false;
  }
  cancel(): void {
    this.Visible = false;
  }

  // 添加指标
  ok(): void {
    let sureCreated = true;
    this.listOfOption.forEach((res: any, index: any) => {
      if (res.field == this.field) {
        this.message.create("error", `该指标名已存在！`);
        sureCreated = false;
      }
    })

    if (sureCreated || this.editFlag) {
      this.Visible = false;
      let newdata = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
      let api = "";
      let countNum = typeof this.countname == "number" ? this.countname : `'${this.countname}'`;
      let condition = String(this.relation + this.operation + countNum);
      if (this.relation == "0") {
        condition = null;
      }
      let data = {};
      if (this.fieldIndex == 0) {
        api = '/addField';
        data = {
          'field': this.field,
          'dbName': this.selectedValue,
          'tableName': this.table,
          'column': this.columndata,
          'associationTable': this.t1,
          'associationKey': this.c1,
          'connectionMode': this.c2,
          'condition': condition,
          'isDate': this.isDatecolum
        }
      } else {
        api = '/addCalc';
        data = {
          'alias': this.field,
          'dbName': this.selectedValue,
          'tableName': this.t1,
          'columnName': this.c1,
          'summaryFunction': this.summaryFunction,
          'condition': condition,
          'isGroup':this.isGroup
        }
      }
      if (this.editFlag) {
        data["id"] = this.editId;
        this.http.post(api, data, newdata).subscribe((res: any) => {
          this.indexarr.push(res);
          this.getFields();
        })
      } else {
        this.http.post(api, data, newdata).subscribe((res: any) => {
          this.indexarr.push(res);
          this.getFields();
        })
      }
    }
  }
  // 新建表名
  tablename() {
    let dbdata = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let api = '/getAllTableNameByDb';
    this.dbName = this.selectedValue;
    this.http.post(api ,this.dbName).subscribe((res: any) => {
      this.tablearr = res;
    })
  }
  // 新建列名
  columne() {
    let dbdata = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let api = '/getColumn';
    this.dbName = this.selectedValue;
    this.columnename = this.table;
    this.http.post(api,this.dbName,this.columnename).subscribe((res: any) => {
      this.columnarr = res;
    })
  }
  // 添加数据源
  handleOk() {
    let httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let data: any = {
      "poolName": this.poolName,
      "driverClassName": this.driverClassName,
      "url": this.url,
      "username": this.username,
      "password": this.password

    }
    let dataapi = '/insertDataSource';
    this.http.post(dataapi, data, httpOptions).subscribe((response: any) => {
      //  将添加的数据源显示出来
      this.arrdata.push(response.poolName);
    })
    this.poolName = '',
      this.driverClassName = '',
      this.url = '',
      this.username = '',
      this.password = '',
      this.isVisible = false;
  }

  handleCancel(): void {
    this.isVisible = false;
    this.builtFlag = false;
    this.modulesFlag = false;
  }

  ngOnInit() {
    this.getPublish();
    this.getFields();
    let httpdata = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    this.arrdata = [];
    this.http.get("/getDB", httpdata).subscribe((res: any) => {
      this.arrdata = res;
    })

    this.getModules();
    this.srv.number1 = [];
  }
  close() {
    this.falg = false;
  }
  // 显示隐藏图形
  show() {
    this.falg = !this.falg;
    this.hidde = false;
  }
  // 修改样式
  obtain(res: any, index: any) {
    this.srv.number1[index].forEach((element:any) => {
      if(element.tip == "tableW"){
        element.value = this.selectedName;
      }
    });
    console.log(this.selectedName)
    console.log(this.srv.number1,index);
    // 利用服务添加图形类型
    this.srv.sendattribute(res, index);
  }
  // 显示隐藏添加数据源
  hidden() {
    this.hidde = !this.hidde;
  }
  getval(name, column) {
    this.line = name;
    this.column = column;
    this.arr = [];
    this.allData["x"] =
      // 发送几行几列
      this.srv.sendline({ x: this.line, y: this.column });
    this.line = '';
    this.column = '';
  }
  // 新增图形
  createPic(key: any) {
    let datasourceName = "total-data";
    if(key.type=='timeseries'){
      datasourceName = "passdata";
    }else if(key.type == 'bilibala-echarts-panel'){
      datasourceName = "teamdata";
    }
    let newtip = []
    newtip.push(
      { name: "图表标题", value: "新建图表", tip: "name" },
      { name: "图表宽度", value: "4", tip: "spans" },
      { name: "图表高度", value: "250", tip: "oneHeight" },
      { name: "图表数据", value: "1", tip: "state" },
      { name: "图表数据源", value: datasourceName, tip: "datasource" },
      { name: "数据单位", value: "", tip: "unit" },
    );

    if (key.type == "barchart") {
      newtip.push(
        { name: "最大值", value: "auto", tip: "max" },
      )
    } else if (key.type == "piechart") {
      newtip.push(
        { name: "饼图形状", value: "pie", tip: "types" },
      )
    } else if (key.type == "table") {
      newtip.push(
        { name: "每列宽度设置", value: [], tip: "tableW" },
      )
    } else if (key.type == "echarts-new-pic") {    // 2023-10-31 Wu新增 由于Echarts图表都是通用一个面板插件所以先暂时维持该图标是这样的
      newtip.push(
        { name:"Echarts图形", value: [], tip: "types" }
      )
    }

    this.srv.number1.push(newtip)
    this.srv.sendrun(key);
  }
  // 删除图形
  deletePic(index: any) {
    this.srv.senddeletepic(index);
  }
  // 修改定时刷新时间
  newData(e: any) {
    this.srv.sendrefresh(e.target.value);
  }
  // 修改定时刷新时间
  newShowTime(e: any) {
    this.srv.sendShowTime(e.target.value);
  }

  changeTheme(e: any) {
    this.ml.bgColor = e.target.value;
    this.srv.sendBasic();
  }


  // 新建模板
  newmodel(): void {
    this.newTitle = "新建模板";
    this.modelvisible = true;
    this.checked = false;
    this.modelarr = null;
    this.getFields();
    this.listOfSelectedValue = null;
    this.modelname = null;
    this.leftPoint = null;
    this.pointTip = null;
    this.rightPoint = null;
    this.timeData = null;
    this.unit = null;
    this.currency = null;
    this.demoValue = null;
    this.modelDetail = null;
    this.editFlagModel = false;
    this.numTest = [{leftPoint:null,pointTip:null,rightPoint:null},{leftPoint:null,pointTip:null,rightPoint:null}];
  }
  okmodel(): void {
    let sureModel = true;
    this.moduleData.forEach((res: any, index: any) => {
      if (res.modelName == this.modelname) {
        this.message.create("error", `该模块名已存在！`);
        sureModel = false;
      }
    })

    if (sureModel || this.editFlagModel) {
      let httpOptions = {
        headers: new HttpHeaders({ 'Content-Type': 'application/json' })
      }
      let topdata = "";
      let bottomdata = "";
      let fieldExpression = "";
      this.numTest.forEach((res:any,index:any)=>{
        for(let i in res){
          if(index==0){
            topdata += res[i]
          }else{
            bottomdata += res[i]
          }
        }
      })
      if(this.numTest[1]["leftPoint"]!=null){
        fieldExpression = topdata+","+bottomdata;
      }else{
        fieldExpression = topdata;
      }
      let data: any = {
        'modelName': this.modelname,
        'allField': this.listOfSelectedValue.toString(),
        'fieldExpression': fieldExpression,
        'dateRange': this.timeData,
        'unit': this.unit,
        'currency': this.currency,
        'queryCount': this.demoValue,
        'explain':this.modelDetail,
        'sortType':this.sortType,
        'sortNum':this.sortNum,
      }
      console.log(data)
      if (this.editFlagModel) {
        data["id"] = this.editId;
        this.http.post('/addModel', data, httpOptions).subscribe((response: any) => {
          this.getModules();
        })
      } else {
        this.http.post('/saveModelData', data, httpOptions).subscribe((response: any) => {
          this.getModules();
        })
      }
      this.modelvisible = false;
    }

  }
  cancelmodel(): void {
    this.modelvisible = false;
  }
  // 多选框方法
  log(value: string[]): void {
    this.modelarr = value;
  }
  // 切换普通指标和计算指标
  tabNum(e: any) {
    this.fieldIndex = e.index;
    if (!this.editFlag) {
      this.field = null;
      this.countname = null;
      this.relation = null;
      this.operation = null;
      this.selectedValue = null;
      this.table = null;
      this.columndata = null;
      this.t1 = null;
      this.c1 = null;
      this.c2 = null;
      this.isDatecolum = null;
      this.summaryFunction = null;
      this.isGroup = null;
    }
  }
  // 所有表的名字
  tableAll() {
    let dbdata = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let api = '/columns';
    if (this.t1) {
      this.dbName = this.selectedValue + "/" + this.table + "," + this.t1;
    } else {
      this.dbName = this.selectedValue + "/" + this.table;
    }
    this.http.get(api + this.dbName, dbdata).subscribe((res: any) => {
      this.tableAllName = res;
    })
  }
  // 获取存储的指标名字
  getFields() {
    let dbdata = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let api = this.ml.serverapi + ':7002/getField/';
    this.http.get(api, dbdata).subscribe((res: any) => {
      console.log(res)
      this.listOfOption = res;
    })
  }
  // 新建关联列名
  assion() {
    let dbdata = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let api = this.ml.serverapi + ':7002/getColumn';
    this.dbName = this.selectedValue;
    this.columnename = this.t1;
    this.http.post(api,this.dbName,this.columnename).subscribe((res: any) => {
      this.assionarr = res;
    })
  }
  // 获取模块中选择的指标
  selectField() {
    this.pointData = [];
    this.listOfOption.forEach((res: any, index: any) => {
      this.listOfSelectedValue.forEach((datas: any, current: any) => {
        if (res['名称'] == datas) {
          this.pointData.push(res)
        }
      })

    })
  }
  // 获取所有存储的module
  getModules() {
    this.sourDataId = null;
    let dbdata = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let api ='/getModel';
    this.http.get(api, dbdata).subscribe((res: any) => {
      this.moduleData = res;
    })
  }
  // 日期方法
  onChange(result: any): void {
    let startData = result[0].getFullYear() + "-" + (result[0].getMonth() + 1) + "-" + result[0].getDate();
    let endData = result[1].getFullYear() + "-" + (result[1].getMonth() + 1) + "-" + result[1].getDate();
    this.timeData = `${startData},${endData}`;
  }


  // 获取发布的内容
  getPublish() {
    this.http.get(this.ml.serverapi + ":7002/getStates").subscribe((res: any) => {
      this.ml.publishDashboard = res;
    })
  }
  // 打开的指标详情页
  detailsPage(res: any) {

    this.countname = null;
    this.relation = null;
    this.operation = null;
    this.field = null;
    this.selectedValue = null;
    this.table = null;
    this.columndata = null;
    this.t1 = null;
    this.c1 = null;
    this.c2 = null;
    this.isDatecolum = null;
    this.isGroup = null;
    this.summaryFunction = null;
    this.detailId = res["指标编号"];
    this.builtFlag = true;
    this.builtContents = [];
    this.http.get(this.ml.serverapi + ":7002/getField/" + this.detailId).subscribe((value: any) => {
      this.selectedValue = value["数据源"] ? value["数据源"] : value["数据源名"];
      this.tablename();
      this.showBuilt = value;
      for (let item in value) {
        this.builtContents.push({ title: item, data: value[item] ? value[item] : "null" });
      }
    })
  }
  // 打开的模块详情页
  detailsModeulePage(res: any) {

    this.countname = null;
    this.relation = null;
    this.operation = null;
    this.field = null;
    this.selectedValue = null;
    this.table = null;
    this.columndata = null;
    this.t1 = null;
    this.c1 = null;
    this.c2 = null;
    this.isDatecolum = null;
    this.summaryFunction = null;
    this.isGroup = null;
    this.numTest = [{leftPoint:null,pointTip:null,rightPoint:null},{leftPoint:null,pointTip:null,rightPoint:null}];
    this.modelDetail = null;
    this.detailId = res["模型编号"];
    this.modulesFlag = true;
    this.modelContent = []
    let pointName = [];
    this.http.post("/getModelById" ,this.detailId).subscribe((value: any) => {
      this.showModel = value;
      for (let item in value) {
        if(item=="指标名称"){
          let selectName = value["指标名称"].split(",");
          this.listOfOption.forEach((res: any) => {
            selectName.forEach((datas: any) => {
              if (res["名称"] == datas) {
                pointName.push(res["名称"])
              }
            })
          })
          this.modelContent.push({ title: item, data: pointName.join(',') ? pointName.join(',') : "null" });
        }else{
          this.modelContent.push({ title: item, data: value[item] ? value[item] : "null" });
        }
      }
    })
  }
  // 删除
  deleteContent() {

    this.modalService.confirm({
      nzTitle: '是否删除？',
      nzOkText: '确定',
      nzOkType: 'primary',
      nzCancelText: '取消',
      nzOnOk: () => {
        // 改了端口和接口
        this.http.post("/DeleteById",this.detailId).subscribe((res: any) => {
          this.closeTip();
          this.getPublish();
          this.getFields();
          this.getModules();
        })
      },
      nzOnCancel: () => {
      }
    });
  }
  // 关闭详情页面
  closeTip() {
    this.modulesFlag = false;
    this.builtFlag = false;
  }
  // 编辑指标
  editData() {
    this.newTitle = "编辑指标";
    this.builtFlag = false;
    this.Visible = true;
    this.editFlag = true;
    this.editFlagModel = false;

    let isTime = false;
    this.editId = this.showBuilt["指标编号"];
    for (let res in this.showBuilt) {
      if (res == "汇总函数") isTime = true;
    }
    if (!isTime) {
      this.fieldIndex = 0;
      this.field = this.showBuilt["名称"];
      this.selectedValue = this.showBuilt["数据源"];

      this.table = this.showBuilt["表名"];
      this.columne();
      this.columndata = this.showBuilt["列名"];
      this.t1 = this.showBuilt["关联表"];
      this.c1 = this.showBuilt["关联键"];
      this.c2 = this.showBuilt["连接方式"]
      this.isDatecolum = this.showBuilt["是否为日期"]
      if (this.t1) {
        this.assion();
      }
      if (this.showBuilt["条件"] == "null" || this.showBuilt["条件"] == "0" || this.showBuilt["条件"] == null) {
        this.relation = null;
        this.countname = null;
        this.operation = null;
      } else {
        let numData = this.showBuilt["条件"].split(/>=|<=|>|=|</g)
        this.tableAll();
        if(numData.length!=1){
          this.relation = numData[0];
          this.countname = numData[1].replaceAll("'", "");
          let unitss = />=|<=|>|=|</g.exec(this.showBuilt["条件"])
          unitss.forEach((res: any) => {
            this.operation = res;
          })
        }else{
          this.relation = null;
          this.countname = null;
          this.operation = null;
        }
      }
    } else {
      this.fieldIndex = 1;
      this.field = this.showBuilt["名称"];
      this.selectedValue = this.showBuilt["数据源名"];
      this.tablename();
      this.t1 = this.showBuilt["表名"];
      this.assion();
      this.c1 = this.showBuilt["列名"];
      this.isGroup = this.showBuilt["是否分组"];
      this.summaryFunction = this.showBuilt["汇总函数"];
      if (this.showBuilt["汇总条件"] == "null" || this.showBuilt["汇总条件"] == null || this.showBuilt["汇总条件"] == "0") {
        this.relation = null;
        this.countname = null;
        this.operation = null;
      } else {
        let numData = this.showBuilt["汇总条件"].split(/>=|>|=|<|<=/g)
        if(numData.length!=1){
          this.relation = numData[0];
          this.countname = numData[2].replaceAll("'", "");
          let unitss = />=|>|=|<|<=/g.exec(this.showBuilt["汇总条件"])
          unitss.forEach((res: any) => {
            this.operation = res;
          })
        }else{
          this.relation = null;
          this.countname = null;
          this.operation = null;
        }
      }
    }
  }

  // 编辑模板
  editModel(){
    console.log(this.showModel)
    this.listOfSelectedValue = [];
    this.newTitle = "编辑模板";
    this.modulesFlag = false;
    this.editFlag = false;
    this.modelvisible = true;
    this.editFlagModel = true;
    this.editId = this.showModel["模型编号"];
    this.modelname = this.showModel["名称"];
    this.modelDetail = this.showModel["模型说明"];
    this.getFields();
    let selectName = this.showModel["指标名称"].split(",");
    this.listOfOption.forEach((res:any)=>{
      selectName.forEach((datas:any)=>{
        if(res["名称"]==datas){
          this.listOfSelectedValue.push(res["名称"]);
        }
      })
    })
    this.selectField();
    this.timeData = this.showModel["统计周期"];
    this.unit = this.showModel["单位"];
    this.currency = this.showModel["币种"];
    this.demoValue = this.showModel["查询数量"];

    if(this.showModel["相关操作"]!=null){

      if(this.showModel["相关操作"][0].indexOf(",")!=-1){
        let twohandel = [];
        twohandel = this.showModel["相关操作"][0].split(/,/g);
        twohandel.forEach((res:any,index:any)=>{
          let numData = res.split(/\+|-|\*|\//g);
          console.log(numData[0].indexOf("undefined")==-1)
          if(numData[0].indexOf("null")!=-1||numData[0].indexOf("undefined")!=-1){
            this.numTest[index] = {leftPoint:null,pointTip:null,rightPoint:null};
          }else{

            this.numTest[index]["leftPoint"] = numData[0];
            this.numTest[index]["rightPoint"] = numData[1];

            let unitss = /\+|-|\*|\//g.exec(res)

            unitss.forEach((data:any)=>{
              console.log(data)
              this.numTest[index]["pointTip"] = data;
            })

          }
        })
      }else{
        let numData = this.showModel["相关操作"][0].split(/\+|-|\*|\//g);
        console.log(numData[0].indexOf("undefined")==-1)
        if(numData[0].indexOf("null")!=-1||numData[0].indexOf("undefined")!=-1){
        }else{
          this.numTest[0]["leftPoint"] = numData[0];
          this.numTest[0]["rightPoint"] = numData[1];

          let unitss = /\+|-|\*|\//g.exec(this.showModel["相关操作"])

          unitss.forEach((res:any)=>{
            console.log(res)
            this.numTest[0]["pointTip"] = res;
          })

        }
      }

    }else{
      this.numTest = [{leftPoint:null,pointTip:null,rightPoint:null},{leftPoint:null,pointTip:null,rightPoint:null}];
    }
  }
  // 清洗数据源
  clearDB(res:any){
    this.http.post(this.ml.serverapi+":7002/cleanData",res).subscribe((res: any) => {
      this.createBasicMessage("数据库清洗成功！");
    })
  }
  // 提示框
  createBasicMessage(title:any): void {
    this.nzMessageService.info(title);
  }
  initSql(){
    let httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    let data: any = {
      "poolName": this.poolName,
      "driverClassName": this.driverClassName,
      "url": this.url,
      "username": this.username,
      "password": this.password

    }
    let dataapi = this.ml.serverapi+':7002/initial';
    this.http.post(dataapi, data, httpOptions).subscribe((response: any) => {
      //  将添加的数据源显示出来
      this.arrdata.push(response.poolName);
    })
    this.poolName = '',
      this.driverClassName = '',
      this.url = '',
      this.username = '',
      this.password = '',
      this.isVisible = false;
  }

  getSelected(){
    this.http.post("/getModelById",this.sourDataId).subscribe((res: any) => {
      console.log(res["指标名称"]);
      this.indexName = res["指标名称"].split(",")
    })
  }

  getIndexData(){
    this.selectedName.push({nama:"",value:""})
  }
  clearIndex(index:any){
    if(this.selectedName.length==1){
      this.selectedName[0] = {name:null,value:null};
    }else{
      this.selectedName.splice(index,1)
    }
  }

}
